





































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Location } from "vue-router";
import _ from "@/boot/lodash";
import i18n from "@/i18n";

// Enums/Data
import { ListDisplayMode } from "@/data/constants";
import { ProductTypes } from "@/data/enums/products";

// Types
import { IProduct } from "@/models/products";

@Component({
  components: {
    "product-image": () =>
      import("@/components/app/global/products/productImage.vue")
  }
})
export default class ProductListItem extends Vue {
  // Props

  @Prop({ default: ListDisplayMode.GRID })
  public displayMode!: ListDisplayMode;

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: null })
  public product!: IProduct;

  @Prop({ default: null })
  public itemRouteName!: string;

  @Prop({ default: false })
  public hasProvisioning!: boolean;

  @Prop({ default: null })
  public selectedProducts!: {
    id: IProduct["id"];
    category_id: IProduct["category_id"];
  }[];

  @Prop({ default: true })
  public isMultiselect!: boolean;

  @Prop({ default: null })
  public disabledProducts!: IProduct["id"][];

  @Prop({ default: false })
  public disableBundles!: boolean;

  @Prop({ default: i18n.t("_action.manage_product") })
  public action!: boolean;

  // Methods

  public itemSelected(value) {
    if (this.isDisabled) return;

    this.$emit("selectProduct", this.product, value);
  }

  public handleActionClick() {
    if (this.$_.isEmpty(this.productRoute)) return;
    this.$router.push(this.productRoute);
  }

  // Computed

  public get isGridView() {
    return this.displayMode === ListDisplayMode.GRID;
  }

  public get showSkeletons() {
    return this.$_.isNull(this.product);
  }

  public get productRoute(): Location {
    if (!this.product || !this.itemRouteName) return {};

    return {
      name: this.itemRouteName,
      params: {
        productId: this.product?.id
      }
    };
  }

  public get isSelectable() {
    return !_.isNil(this.selectedProducts);
  }

  public get isSelected() {
    return (
      this.isSelectable &&
      _.some(this.selectedProducts, ["id", this.product?.id])
    );
  }

  public get isDisabled() {
    return (
      (!_.isNil(this.disabledProducts) &&
        this.disabledProducts.includes(this.product?.id)) ||
      (this.disableBundles &&
        this.product.product_type === ProductTypes.PRODUCT_BUNDLE)
    );
  }
}
